import { useState } from "react";
import { Tags } from "lucide-react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usePoll } from "@/hooks/usePoll";
import { api } from "@/lib/api";
import { PageHeader, Panel, Empty } from "@/components/common";
import { CrudActions, AddButton, confirmDelete, FormDialog, TextField } from "@/components/Crud";

export default function Categories() {
  const { data, reload } = usePoll("/categories", 0);
  const subs = usePoll("/subcategories", 0).data || [];
  const menus = usePoll("/menus", 0).data || [];
  const [edit, setEdit] = useState(null);
  const [name, setName] = useState("");

  const openForm = (c) => { setEdit(c || {}); setName(c?.name || ""); };
  const save = async () => {
    if (edit.id) await api.put(`/categories/${edit.id}`, { name });
    else await api.post("/categories", { name });
    toast.success("Kategori disimpan");
    reload();
  };

  return (
    <div>
      <PageHeader title="Kategori Menu" subtitle="Kelompok utama menu, misal Makanan & Minuman">
        <AddButton testId="add-category-btn" label="Tambah Kategori" onClick={() => openForm()} />
      </PageHeader>
      <Panel>
        {data?.length === 0 ? <Empty icon={Tags} text="Belum ada kategori" /> : (
          <Table data-testid="category-table">
            <TableHeader><TableRow><TableHead>Nama Kategori</TableHead><TableHead>Sub Kategori</TableHead><TableHead>Menu</TableHead><TableHead className="text-right">Aksi</TableHead></TableRow></TableHeader>
            <TableBody>
              {(data || []).map((c) => (
                <TableRow key={c.id} data-testid={`category-row-${c.id}`}>
                  <TableCell className="font-semibold">{c.name}</TableCell>
                  <TableCell>{subs.filter((s) => s.category_id === c.id).length}</TableCell>
                  <TableCell>{menus.filter((m) => m.category_id === c.id).length}</TableCell>
                  <TableCell><CrudActions id={`category-${c.id}`} onEdit={() => openForm(c)} onDelete={() => confirmDelete(`/categories/${c.id}`, reload, "kategori")} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Panel>
      <FormDialog testId="category-form-dialog" open={!!edit} onOpenChange={(o) => !o && setEdit(null)} title={edit?.id ? "Ubah Kategori" : "Tambah Kategori"} onSubmit={save}>
        <TextField label="Nama Kategori" testId="category-name-input" required value={name} onChange={(e) => setName(e.target.value)} />
      </FormDialog>
    </div>
  );
}
